import { useContext } from 'react';
import ConsentContext, { ConsentContextValue } from './ConsentContext';

const useConsentContext = (): ConsentContextValue => {
  const value = useContext(ConsentContext);
  if (!value) throw new Error('useConsentContext must be used inside a ConsentProvider');
  return value;
};

export default useConsentContext;
